// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DriverStateMapper from "../entity-mapper/DriverStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = DriverStateMapper.driverBuilder;

var DriverProfileRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var DriverProfileResponseConverter = partial_arg(DriverProfileRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return DriverStateMapper.PartnerDocuments.execute(data);
}

var PartnerDocumentRepoConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerDocumentResponseConverter = partial_arg$1(PartnerDocumentRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$2(data) {
  return DriverStateMapper.PartnerWaitlist.execute(data);
}

var PartnerWaitlistRepoConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerWaitlistResponseConverter = partial_arg$2(PartnerWaitlistRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(data) {
  return DriverStateMapper.PartnerOnboarding.execute(data);
}

var PartnerOnboardingRepoConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerOnboardingResponseConverter = partial_arg$3(PartnerOnboardingRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$4(data) {
  return DriverStateMapper.FilterDriverResponseMapper.execute(data);
}

var FilterDriverRepoConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var FilterDriverResponseConverter = partial_arg$4(FilterDriverRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  DriverProfileRepoConfig ,
  DriverProfileResponseConverter ,
  PartnerDocumentRepoConfig ,
  PartnerDocumentResponseConverter ,
  PartnerWaitlistRepoConfig ,
  PartnerWaitlistResponseConverter ,
  PartnerOnboardingRepoConfig ,
  PartnerOnboardingResponseConverter ,
  FilterDriverRepoConfig ,
  FilterDriverResponseConverter ,
  
}
/* DriverProfileResponseConverter Not a pure module */
